// frontend/src/components/QueuedToast.tsx
import React, { useEffect, useState } from 'react';
import NotificationToast from './NotificationToast';

export type ToastItem = { message: string; type: 'success' | 'error' | 'info' | 'warning'; duration?: number };

// Simple global queue to ensure only one toast is shown at a time
const getQueue = (): ToastItem[] => {
  const w = window as any;
  if (!w.__auralink_toast_queue) w.__auralink_toast_queue = [];
  return w.__auralink_toast_queue as ToastItem[];
};
const setActiveFlag = (active: boolean) => { (window as any).__auralink_toast_active = active; };
const isActive = (): boolean => !!(window as any).__auralink_toast_active;

export function pushToast(item: ToastItem) {
  const q = getQueue();
  q.push(item);
  window.dispatchEvent(new CustomEvent('auralink-toast-queue.update'));
}

export default function QueuedToast() {
  const [current, setCurrent] = useState<ToastItem | null>(null);

  useEffect(() => {
    function tryShowNext() {
      if (isActive()) return; // already showing
      const q = getQueue();
      if (q.length === 0) return;
      // Rotate: take first item and move it to end after showing
      const next = q.shift()!;
      setCurrent(next);
      setActiveFlag(true);
    }
    tryShowNext();
    const onUpdate = () => tryShowNext();
    window.addEventListener('auralink-toast-queue.update', onUpdate);
    return () => window.removeEventListener('auralink-toast-queue.update', onUpdate);
  }, []);

  if (!current) return null;
  return (
    <NotificationToast
      message={current.message}
      type={current.type}
      duration={current.duration ?? 5000}
      onClose={() => {
        setActiveFlag(false);
        setCurrent(null);
        // Trigger check for next
        window.dispatchEvent(new CustomEvent('auralink-toast-queue.update'));
      }}
    />
  );
}
